import script from "./SearchedFoodCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchedFoodCard.vue?vue&type=script&setup=true&lang=js"

import "./SearchedFoodCard.vue?vue&type=style&index=0&id=3755daa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3755daa5"]])

export default __exports__